export default __webpack_public_path__ + "static/4-73e8e25478767f149cb149169ceda78f.png";